export enum SLMRelationshipStatus {
  INIT, // 初始|未报名
  RECEIVED_COUPON, // 已领优惠券
  LIFTED, // 好友解除
  FUNDED, // 已购买
  REFUNDED, // 退课
}
export interface SLMRelationship {
  id: number;
  userId: number;
  inviterId: number;
  orderId: number;
  slmId: number;
  status: SLMRelationshipStatus;
  source: number;
  isBindMobile: boolean;
}



// WEBPACK FOOTER //
// ./src/types/slm.ts